/*
 *
 * KitStartTtl
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 26-Sep-2025
*/

import KitStartTtl from './KitStartTtlContainer'

export default KitStartTtl
